import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerOnboardingFormComponent } from './customer-onboarding-form/customer-onboarding-form.component';
import { CustomerOnBoardingRoutingModule } from './customer-onboarding-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CustomerOnboadingEditFormComponent } from './customer-onboading-edit-form/customer-onboading-edit-form.component';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    CustomerOnboardingFormComponent,
    CustomerOnboadingEditFormComponent
  ],
  imports: [
    CommonModule,
    CustomerOnBoardingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule,
    NgbModalModule,
    ImageCropperComponent,
    MatTooltipModule
  ]
})
export class CustomerOnboardingModule { }
